module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', [(_vm.type === undefined) ? _c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    staticClass: "mx-2"
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "fab": "",
      "large": "",
      "to": "/Admin/User"
    }
  }, [_c('v-icon', [_vm._v("person")])], 1), _vm._v(" "), _c('p', [_vm._v("User Manager")])], 1)])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    staticClass: "mx-2"
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "fab": "",
      "large": "",
      "to": "/Admin/Customer"
    }
  }, [_c('v-icon', [_vm._v("mdi-account-group")])], 1), _vm._v(" "), _c('p', [_vm._v("Customer Manager")])], 1)])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    staticClass: "mx-2"
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "fab": "",
      "large": "",
      "to": "/Admin/Supplier"
    }
  }, [_c('v-icon', [_vm._v("assignment_ind")])], 1), _vm._v(" "), _c('p', [_vm._v("Supplier Manager")])], 1)])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    staticClass: "mx-2"
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "fab": "",
      "large": "",
      "to": "/Admin/Vehicle"
    }
  }, [_c('v-icon', [_vm._v("local_shipping")])], 1), _vm._v(" "), _c('p', [_vm._v("Vehicle Manager")])], 1)])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    staticClass: "mx-2"
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "fab": "",
      "large": "",
      "to": "/Admin/Product"
    }
  }, [_c('v-icon', [_vm._v("assignment")])], 1), _vm._v(" "), _c('p', [_vm._v("Product Template Manager")])], 1)])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    staticClass: "mx-2"
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "fab": "",
      "large": "",
      "to": "/Admin/Device"
    }
  }, [_c('v-icon', [_vm._v("router")])], 1), _vm._v(" "), _c('p', [_vm._v("Device Template Manager")])], 1)])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs6": ""
    }
  }, [_c('v-card', {
    staticClass: "mx-2"
  }, [_c('div', {
    staticClass: "text-xs-center"
  }, [_c('v-btn', {
    attrs: {
      "color": "primary",
      "fab": "",
      "large": "",
      "to": "/AuditLog"
    }
  }, [_c('v-icon', [_vm._v("mdi-database-search")])], 1), _vm._v(" "), _c('p', [_vm._v("Audit Log")])], 1)])], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.type === 'User') ? _c('user-view', {
    attrs: {
      "xs12": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'Customer') ? _c('customer-view', {
    attrs: {
      "xs12": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'Supplier') ? _c('supplier-view', {
    attrs: {
      "xs12": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'Product') ? _c('product-view', {
    attrs: {
      "xs12": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'Device') ? _c('device-view', {
    attrs: {
      "xs12": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type === 'Vehicle') ? _c('vehicle-view', {
    attrs: {
      "xs12": ""
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b841337c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Admin.vue
// module id = 763
// module chunks = 1